import { ModalTitle } from '../ReviewsWizard/ModalTitle'
import { Portal } from 'components/Portal/Portal'
import Avatar from 'common/Avatar/Avatar'
import Styles from './InviteEmails.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useReviewConfig } from './ReviewConfigProvider'
import { type ModalPortals } from './CreateReviewActionConfigModal'
import { RecipientsSelectorValueType } from 'types'
import { Modal } from 'almanac-ui/Modal'

interface Props extends ModalPortals {
  onBack: () => void
}

export const InviteEmails = ({ header, footer, onBack }: Props) => {
  const { onSubmit, reviewers, approvers, viewers } = useReviewConfig()
  const workspace = useCurrentWorkspace()
  const canInviteToWorkspace = !workspace?.guest

  const newEmails = [...reviewers, ...approvers, ...viewers]
    .filter((reviewer) => reviewer.type === RecipientsSelectorValueType.Email)
    .map((reviewer) => reviewer.value) as string[]

  return (
    <>
      <Portal container={header}>
        <ModalTitle className={Styles.title}>Invite collaborators outside of your workspace</ModalTitle>
      </Portal>
      <div>
        <div className={Styles.bodyText}>
          These people are not a part of your workspace.{' '}
          {canInviteToWorkspace && 'Would you like to add them to the workspace?'} Guests can edit the document and make
          changes.
        </div>
        <ul className={Styles.emails}>
          {newEmails.map((email) => {
            return (
              <li key={email} className={Styles.email}>
                <Avatar url={null} label={email[0]} size={32} randomColor />
                <div>{email}</div>
              </li>
            )
          })}
        </ul>
      </div>
      <Portal container={footer}>
        <Modal.Footer>
          <Modal.FooterContent slot="left">
            <Modal.FooterButton variant="tertiary" size="lg" onPress={onBack}>
              Cancel
            </Modal.FooterButton>
          </Modal.FooterContent>
          <Modal.FooterContent slot="center">
            {canInviteToWorkspace && (
              <Modal.FooterButton variant="secondary" size="lg" onPress={() => onSubmit(false)}>
                Invite as Guests to this Review
              </Modal.FooterButton>
            )}
          </Modal.FooterContent>
          <Modal.FooterContent slot="right">
            <Modal.FooterButton
              onPress={() => onSubmit(canInviteToWorkspace)}
              data-heap-id="submit-feedback-request"
              size="lg"
              variant="primary"
            >
              {canInviteToWorkspace ? 'Invite to Workspace' : 'Invite as Guests to this Review'}
            </Modal.FooterButton>
          </Modal.FooterContent>
        </Modal.Footer>
      </Portal>
    </>
  )
}
